export default {
  getRoles() {
    return [
      { id: 1, name: "addetto stampa" },
      { id: 2, name: "collaboratore" },
      { id: 3, name: "comitato regionale" },
      { id: 4, name: "commissario di gara" },
      { id: 5, name: "coordinatore" },
      { id: 6, name: "cronometrista" },
      { id: 7, name: "direttore tecnico" },
      { id: 8, name: "fisioterapista" },
      { id: 9, name: "fornitore" },
      { id: 10, name: "fotografo" },
      { id: 11, name: "giornalista" },
      { id: 12, name: "influencer e brand ambassador" },
      { id: 13, name: "meccanico-tecnico" },
      { id: 14, name: "medico di gara" },
      { id: 15, name: "partner" },
      { id: 16, name: "partner tecnico" },
      { id: 17, name: "personale motoclub" },
      { id: 18, name: "pilota" },
      { id: 19, name: "presidente" },
      { id: 35, name: "presidente regionale" },
      { id: 34, name: "consigliere federale" },
      { id: 20, name: "responsabile" },
      { id: 21, name: "sponsor" },
      { id: 22, name: "team manager" },
      { id: 23, name: "tecnico federale" },
      { id: 24, name: "ufficio marketing" },
      { id: 25, name: "funzionario" },
      { id: 26, name: "addetto alla sicurezza" },
      { id: 27, name: "volontario" },
      { id: 28, name: "addetto alla manutenzione" },
      { id: 29, name: "account manager" },
      { id: 30, name: "consulente legale o legale rappresentante" },
      { id: 33, name: "freelance" },
      { id: 31, name: "familiare" },
      { id: 32, name: "ospite" },
    ];
  },
};
